import { HttpParams } from "@angular/common/http";

export class HttpParamUtil
{
    public static ConvertToHttpParameters<T>(entity: any): HttpParams {
        let httpParams = new HttpParams();
        Object.keys(entity)
          .filter(key => {
            const v = entity[key];
            return Array.isArray(v) || typeof v === 'string'
              ? v.length > 0
              : v !== null && v !== undefined;
          })
          .forEach(key => {
            httpParams = httpParams.set(key, entity[key]);
          });
        return httpParams;
      }
}